<script setup lang="ts">
/**
 * Bloc "Paiement indisponible" (organisateur n'a pas configuré Stripe/PayPal).
 * Partagé entre /a/[slug] et /b/[slug].
 */
defineProps<{
  message?: string;
}>();
</script>

<template>
  <div class="bg-white dark:bg-[#141414] rounded-3xl shadow-[0_1px_3px_rgba(45,46,92,0.12)] overflow-hidden">
    <div class="flex flex-col items-center justify-center text-center px-6 py-10">
      <img
src="/svg/hand-stripe.svg" alt="" class="w-28 h-28 mb-6"
        width="232"
        height="230"
      />
      <h3 class="text-lg font-bold text-[#2d2e5c] dark:text-white mb-2">
        {{ $t("association.publicPage.paiementIndisponible") }}
      </h3>
      <p class="text-sm text-[#717198] dark:text-gray-400 max-w-sm">
        {{ message || $t("association.publicPage.paiementIndisponibleMessage") }}
      </p>
    </div>
  </div>
</template>
